import { motion } from "framer-motion";

import AnimatedCounter from "../../AnimatedCounter/AnimatedCounter";
import Container from "../../Container/Container";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";

import "../../../Style/home/trustStats.css";

const stats = [
  { id: 1, value: 10, suffix: "K+", label: "Leads Generated" },
  { id: 2, value: 250, suffix: "+", label: "Businesses Served" },
  { id: 3, value: 98, suffix: "%", label: "Client Satisfaction" },
  { id: 4, value: 15, suffix: "+", label: "Years Experience" },
];

/** Floating stats strip that overlaps the bottom of the hero. */
function TrustStats() {
  return (
    <section className="trust-stats">
      <Container>
        <motion.div
          className="trust-stats__panel"
          variants={staggerContainer(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {stats.map((stat) => (
            <motion.div key={stat.id} className="trust-stats__item" variants={fadeUp()}>
              <AnimatedCounter value={stat.value} suffix={stat.suffix} className="trust-stats__value" />
              <span className="trust-stats__label">{stat.label}</span>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default TrustStats;
